import "./App.scss";
import Routes from "./routes";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import CookieBanner from "./CookieBanner.connected";

const App = () => {
  return (
    <>
      <Routes />
      <ToastContainer position="bottom-left" />
      <CookieBanner />
    </>
  );
};

export default App;
